import styles from "./index.module.scss";

type TMoreProps = {
  isMobile: boolean;
  getNotes: (key: string) => void;
};

export default function ButtonMore(props: TMoreProps): JSX.Element {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    /** call parent function */
    props.getNotes("more");
  };

  return (
    <div className={[styles.box, props.isMobile ? styles.mobile : ""].join(" ")}>
      <button className={styles.btn} onClick={handleClick} data-e="notes-more-btn">
        Wczytaj więcej
      </button>
    </div>
  );
}
